 /* eslint-disable */
import React from 'react'
import styled from 'styled-components'

import Container from '../Container'

interface PageHeaderProps {
  icon?: React.ReactNode
  subtitle?: string
  title?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({ icon, subtitle, title }) => {
  return (
    <Container size="sm">
      <StyledPageHeader>
        {icon !== undefined　&& icon !== "" ? (<StyledImg src={require(`../../assets/img/${icon}.png`)} />):(<div/>)}
        <StyledTitle>{title}</StyledTitle>
        <StyledSubtitle>{subtitle}</StyledSubtitle>
      </StyledPageHeader>
    </Container>
  )
}

const StyledPageHeader = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding-bottom: ${(props) => props.theme.spacing[6]}px;
  padding-top: ${(props) => props.theme.spacing[6]}px;
  margin: 0 auto;
`

const StyledIcon = styled.div`
  font-size: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  width: 80px;
`

const StyledTitle = styled.h1`
  font-family: 'Oswald', sans-serif;
  color: ${(props) => props.theme.color.white};
  font-size: 36px;
  font-weight: 700;
  margin: 0;
  padding: 0;
`

const StyledSubtitle = styled.h3`
  color: ${(props) => props.theme.color.white};
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  padding: 0;
  text-align: center;
`
const StyledImg = styled.img`
  alt: '🤔'
  height: 60px;
  width: 60px;
`

export default PageHeader

/*
<StyledIcon>{icon}</StyledIcon>
*/